<template>
<div class="corporation_common_content">
  <tenantDashboardInfo></tenantDashboardInfo>
  <tenantCommonInfo></tenantCommonInfo>
</div>
</template>

<script>
import tenantCommonInfo from './corporationCommonComponents/tenantCommonInfo.vue'
import tenantDashboardInfo from './corporationCommonComponents/tenantDashboardInfo.vue'

export default {
  data () {
    return {
    }
  },
  computed: {
  },
  async created () {
    await this.$store.dispatch('systemAdminDefine/clearCompanyInfo')
  },
  components: {
    tenantCommonInfo,
    tenantDashboardInfo
  },
  methods: {
  }
}
</script>
<style scoped>
.content,
.bottom {
  width: calc(100% - 262px);
}
.table_contents {
  width: 10%;
}
</style>



// WEBPACK FOOTER //
// src/components/masterPanel/masterView/corporationCommonView/corporationCommonList.vue